// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag_delete_body[data-v-dddec152] {\n  min-height: 150px;\n}\n.tag_delete_text[data-v-dddec152] {\n  color: white;\n  text-align: center;\n  padding: 1rem 1.5rem;\n  margin-top: 0.5rem;\n  font-size: 1rem;\n}\n.tag_delete_cancel_btn[data-v-dddec152] {\n  background-color: #4E4E4E !important;\n  color: white !important;\n}\n.tag_delete_confirm_btn[data-v-dddec152] {\n  background-color: #CA4848 !important;\n  color: white !important;\n}", ""]);
// Exports
module.exports = exports;
